<template>
  <v-navigation-drawer
  >
    <v-list density="compact" nav v-model:opened="openedGroups">
      <v-list-item
          :prepend-icon="'$mdiHome'"
          title="Главная"
          value="home"
          :to="'/'"
      ></v-list-item>
      <v-list-item
          :prepend-icon="'$mdiFolder'"
          title="Поставщики"
          value="suppliers"
          :to="'/suppliers'"
      ></v-list-item>
      <v-list-item
          :prepend-icon="'$mdiFolder'"
          title="Страницы сайта"
          value="content-pages"
          :to="'/content-pages'"
      ></v-list-item>
      <v-list-item
          :prepend-icon="'$mdiFolder'"
          title="Баннеры"
          value="banners"
          :to="'/banners'"
      ></v-list-item>
      <v-list-item
          :prepend-icon="'$mdiFolder'"
          title="Пункты меню категорий"
          value="menu-categories"
          :to="'/menu-categories'"
      ></v-list-item>
      <v-list-item
          :prepend-icon="'$mdiFolder'"
          title="Теги подкатегорий"
          value="subcategory-tags"
          :to="'/subcategory-tags'"
      ></v-list-item>
      <v-list-group
          value="categories-group"
          prepend-icon="$mdiFolder"
          :title="'Категории'"
      >
        <template v-slot:activator="{ props }">
          <v-list-item
              v-bind="props"
          ></v-list-item>
        </template>
        <v-list-item
            title="Список категорий"
            :to="'/categories'"
            value="categories-list"
        ></v-list-item>
        <v-list-item
            title="Создать категорию"
            value="categories-edit"
            :to="'/categories/edit'"
        ></v-list-item>
      </v-list-group>

      <v-list-group
          value="subcategories-group"
          prepend-icon="$mdiFolder"
          :title="'Подкатегории'"
      >
        <template v-slot:activator="{ props }">
          <v-list-item
              v-bind="props"
          ></v-list-item>
        </template>
        <v-list-item
            title="Список подкатегорий"
            :to="'/subcategories'"
            value="subcategories-list"
        ></v-list-item>
        <v-list-item
            title="Создать подкатегорию"
            value="subcategories-edit"
            :to="'/subcategories/edit'"
        ></v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
export default {
  data() {
    return {
      openedGroups: ["categories-group", "subcategories-group"]
    }
  }
};
</script>
<style scoped>
.menu-panel {
  background: #393939;
  height: 100%;
}

.menu-panel a {
  color: #fff;
  display: flex;
  font-size: 0.8em;
  min-height: 40px;
  align-items: center;
  position: relative;
  padding: 0 10px;
}

.menu-panel a:hover,
.menu-panel a.router-link-exact-active {
  background-color: #1697f6; /*rgb(0, 105, 255)*/
}

.menu-panel a:hover::after,
.menu-panel a.router-link-exact-active::after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 4px;
  height: 100%;
  background-color: rgb(0, 105, 255);
}
</style>
